import { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { snackbarModel } from '../../../features/snackbar';
import { createNotification } from '../../../features/snackbar/lib';
import { teamsModel } from '../../../features/teams';
import { callApi } from '../../../shared/api';

export const useDownloadMp4 = (id: string) => {
  const dispatch = useDispatch();
  const { id: teamId } = useSelector(
    teamsModel.selectors.selectCurrentTeamWithError
  );

  const [isLoading, setIsLoading] = useState(false);

  const handleDownload = useCallback(() => setIsLoading(true), []);

  useEffect(() => {
    if (!isLoading) {
      return;
    }

    let cancelled = false;

    const handleFetch = () => {
      callApi
        .downloadMp4(id, { teamId })
        .then((res) => {
          if (cancelled) {
            return;
          }

          if (res.url) {
            setIsLoading(false);
            window.open(res.url, '_blank');
            return;
          }
        })
        .catch(() => {
          dispatch(
            snackbarModel.actions.addNotificationAction(
              createNotification('error', 'Failed to download call')
            )
          );
          setIsLoading(false);
        });
    };

    const ref = setInterval(() => handleFetch(), 1_500);
    handleFetch();

    return () => {
      cancelled = true;
      clearInterval(ref);
    };
  }, [dispatch, isLoading, id, teamId]);

  return {
    isLoading,
    handleDownload,
  };
};
